import { render, staticRenderFns } from "./CodeRow.vue?vue&type=template&id=0654c2cd&scoped=true&"
import script from "./CodeRow.vue?vue&type=script&lang=js&"
export * from "./CodeRow.vue?vue&type=script&lang=js&"
import style0 from "./CodeRow.vue?vue&type=style&index=0&id=0654c2cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654c2cd",
  null
  
)

export default component.exports